import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getUsers, deleteUser } from "../../../api/usersApi";
import './styles/usersList.css';
import swal from "sweetalert";
import { FaUser, FaUserEdit, FaUserTimes } from "react-icons/fa";
import { SiNamecheap } from "react-icons/si";
import { MdOutlineAlternateEmail, MdOutlineWork } from "react-icons/md";
import { FaUserPlus } from "react-icons/fa6";

export function UsersList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getUsers()
      .then(data => setUsers(data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  async function handleDelete(id) {
    swal({
      title: "Alert",
      text: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
      icon: "warning",
      buttons: ["Non", "Oui"],
      dangerMode: true,
    }).then(async (willContinue) => {
      if (willContinue) {
        try {
          await deleteUser(id);
          setUsers(us => us.filter(u => u.id !== id));
          swal("Utilisateur supprimé avec succès !", "", "success");
        } catch (e) {
          console.error(e);
          swal("Erreur", "La suppression a échoué !", "error");
        }
      } else {
        swal("Suppression annulée !");
      }
    });
  }

  // Loading skeleton component
  const LoadingSkeleton = () => (
        <div className="loading-card">
          <p>
          Chargement ...
          </p>
        </div>
  );

  return (
    <div className={`users ${loading ? 'loading' : ''}`}>
      <h2 className="H2-users">Users</h2>
      <Link to={'/admin/add-user'} className="add-user"><FaUserPlus className="add-user-icon"/> Ajouter un utilisateur</Link>
      {loading ? (
        <LoadingSkeleton />
      ) :
        <ul className="ul-users">
          {users.length === 0 ? (
            <li className="empty-state">
              <div className="empty-icon"><FaUser /></div>
              <h3>Aucun utilisateur trouvé</h3>
              <p>Commencez par ajouter votre premier utilisateur</p>
            </li>
          ) : (
            users.map(u => (
              <li key={u.id}>
                <div className="detailsU">
                  <FaUser className="user-icon"/>
                  <p><SiNamecheap /><strong>Nom :</strong> {u.nom}</p>
                  <p><MdOutlineAlternateEmail /><strong>Email :</strong> {u.email || 'Pas de email'}</p>
                  <p className="Role-user"><MdOutlineWork /><strong>Role :</strong> {u.role || 'Pas de Role !!'}</p>
                </div>
                <div className="actionsU">
                  <Link to={'/admin/edit/user/' + u.id} className="edit"><FaUserEdit className="edit-icon"/> Edit</Link>
                  <button onClick={() => handleDelete(u.id)} className="delete"><FaUserTimes className="delete-icon"/> Delete</button>
                </div>
              </li>
            ))
          )}
        </ul>
      }
    </div>
  );
}